import { onceEach } from "./once.js";
import { setupTippyHint } from "./hint_util.js";

export const scanHints = (el) => {
  onceEach(el.querySelectorAll("[data-hint], [data-hint-html]"), "hint", setupTippyHint);
};

document.addEventListener("DOMContentLoaded", () => scanHints(document));
document.addEventListener("partial:replace", (ev) => scanHints(ev.container));
